import { render, staticRenderFns } from "./NoAvailableContent.vue?vue&type=template&id=11d4a806&"
import script from "./NoAvailableContent.vue?vue&type=script&lang=js&"
export * from "./NoAvailableContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports